module.exports = __webpack_public_path__ + "static/media/golf-carousel-1024x1366.1cad99c9.jpg";